<template lang="pug">
  div.weaponModList
    van-grid(:column-num="3", :center="false")
      van-grid-item(v-for="item in dataList", @click="showWeaponModContent(item)")
        div.weaponModItem
          img(alt="", v-lazy="require('../assets/weapon_mod_icon/'+item.weaponModIcon)")
</template>

<script>
export default {
  name: 'WeaponModList',
  data() {
    return {
      dataList:[],
      weaponModItemList:[],
    }
  },
  created() {
    
  },
  methods:{
    initList() {
      for (let index = 0; index < this.weaponModItemList.length; index++) {
        this.dataList.push(this.weaponModItemList[index])
      }
    },
    showWeaponModContent(item) {
      this.$router.push({
          path: "/weaponMod/content/"+item.weaponModId
      })
    }
  },
  components:{

  },
  mounted() {
    let wikiData = require("../assets/lang/zh_CN.json")
    this.$nextTick(() => {
      this.weaponModItemList = wikiData.weaponModItemList
      this.initList()
    })
  }
}
</script>

<style lang="scss">
.weaponModList {
  .van-grid-item__content {
    padding: 0px;
    min-width: 114px;
    height: 140px;
    background: url("../assets/weapon_mod_list_icon_bg.png") center no-repeat;
    background-size: contain;
  }
  .van-hairline--top::after {
    border-top-width: 0px;
  }
  .van-grid-item__content::after{
    border-width: 0px;
  }
  .van-grid-item {
    padding: 10px 0;
    justify-content: center;
    display: flex;
  }
  .weaponModItem {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 68px;
    height: 91px;
  }
  .weaponModItem img {
    width: 100%;
    height: 100%;
  }
}
</style>